// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jupyter-matplotlib {
    width: auto;
    height: auto;
    flex: 1 1 auto;
}

/* Toolbar */

.jupyter-matplotlib-toolbar {
    position: absolute;
    overflow: visible;
    z-index: 100;
}

.jupyter-matplotlib-toolbar-fadein-fadeout {
    transition: visibility 0.5s linear, opacity 0.5s linear;
}

.jupyter-matplotlib-button {
    width: calc(var(--jp-widgets-inline-width-tiny) / 2 - 2px);
    padding: 0 !important;
}

/* Figure */

.jupyter-matplotlib-figure {
    width: fit-content;
    height: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.jupyter-matplotlib-canvas-container {
    overflow: auto;
}

.jupyter-matplotlib-canvas-div {
    margin: 2px;
    flex: 1 1 auto;
}

.jupyter-matplotlib-header {
    width: 100%;
    text-align: center;
}

.jupyter-matplotlib-footer {
    width: 100%;
    text-align: center;
    min-height: var(--jp-widgets-inline-height);
}
`, "",{"version":3,"sources":["webpack://./css/mpl_widget.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,YAAY;;AAEZ;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,0DAA0D;IAC1D,qBAAqB;AACzB;;AAEA,WAAW;;AAEX;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,2CAA2C;AAC/C","sourcesContent":[".jupyter-matplotlib {\n    width: auto;\n    height: auto;\n    flex: 1 1 auto;\n}\n\n/* Toolbar */\n\n.jupyter-matplotlib-toolbar {\n    position: absolute;\n    overflow: visible;\n    z-index: 100;\n}\n\n.jupyter-matplotlib-toolbar-fadein-fadeout {\n    transition: visibility 0.5s linear, opacity 0.5s linear;\n}\n\n.jupyter-matplotlib-button {\n    width: calc(var(--jp-widgets-inline-width-tiny) / 2 - 2px);\n    padding: 0 !important;\n}\n\n/* Figure */\n\n.jupyter-matplotlib-figure {\n    width: fit-content;\n    height: auto;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.jupyter-matplotlib-canvas-container {\n    overflow: auto;\n}\n\n.jupyter-matplotlib-canvas-div {\n    margin: 2px;\n    flex: 1 1 auto;\n}\n\n.jupyter-matplotlib-header {\n    width: 100%;\n    text-align: center;\n}\n\n.jupyter-matplotlib-footer {\n    width: 100%;\n    text-align: center;\n    min-height: var(--jp-widgets-inline-height);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
